module.exports = __webpack_public_path__ + "static/media/delete-icon.68d55805.svg";